export enum RoutingType {
  Dynamic = 'dynamic',
  Demand = 'demand',
  Bus = 'bus',
  Exo = 'exo',
}